import { getIdToken, signOut as authSignOut } from "firebase/auth";
import { auth } from "../config/firebase";

export function signOut() {
  return authSignOut(auth);
}

export async function getFirebaseIdToken(forceRefresh = false): Promise<string | null> {
  const currentUser = auth.currentUser;
  if (!currentUser) return null;
  
  try {
    return await getIdToken(currentUser, forceRefresh);
  } catch (error) {
    throw error;
  }
}